<template>
  <div
    class="d-flex flex-column align-start justify-start tree-view"
    :style="{ maxHeight: `${maxHeight}px` }"
  >
    <div class="option-actions">
      <button
        v-if="showSelectAll"
        type="button"
        :class="['select-all', allAreSelected ? 'checked' : '']"
        @click="$emit('select-all')"
      >
        {{ allAreSelected ? 'Unselect all' : 'Select all' }}
      </button>
      <button
        v-if="showClearSelection"
        type="button"
        class="clear-selection"
        @click="$emit('update:selectedFilters', [])"
      >
        Clear selection ({{ modelValue.length }})
      </button>
    </div>
    <TreeItem
      v-for="option in options"
      :key="option[idKey]"
      :option="option"
      :selected="modelValue"
      :level-has-children="anyHaveChildren"
      :id-key="idKey"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <template #option-label="{ option: slotOption }">
        <slot
          name="option-label"
          :option="slotOption"
        />
      </template>
    </TreeItem>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';

const TreeItem = defineAsyncComponent(() => import('@/components/filter/treeSelectNewDesign/TreeItemNew.vue'));

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  maxHeight: {
    type: Number,
    default: 300,
  },
  idKey: {
    type: String,
    default: 'id',
  },
  showSelectAll: {
    type: Boolean,
    default: false,
  },
  allAreSelected: {
    type: Boolean,
    default: false,
  },
});

const anyHaveChildren = computed(() => props.options.some((option) => option.children?.length));

const showClearSelection = computed(() => props.modelValue?.length);

defineEmits(['update:modelValue', 'select-all', 'update:selectedFilters']);
</script>

<style lang="less" scoped>
.tree-view {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.option-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  button {
    font-size: 12px;
    font-weight: 500;

    &:hover {
      cursor: pointer;
    }
  }
}

.clear-selection {
  margin-left: auto;
  color: @basic-red;
}

.select-all {
  color: @text-light;

  &:hover {
    color: @text-brand;
  }

  &.checked {
    color: @text-brand;
  }
}
</style>
